import React from 'react'
import CreateResume from './CreateResume'

function ResumeBuilder() {


    return (
        <>
            <CreateResume />
        </>
    )
}

export default ResumeBuilder
